<template>
    <section class="section bg-secondary" id="reviews">
        <div class="container">
            <h2 class="section-title" v-scroll-reveal>
                <span class="_order">03</span>
                <span class="_title" v-html="'Facebook ' + $t('Reviews')"></span>
            </h2>

            <div class="flex flex-wrap -mx-2 md:-mx-base xl:-mx-lg -mb-lg">
                <div class="w-full md:w-1/3 px-2 md:px-base xl:px-lg mb-lg">
                    <div class="review-box text-white" v-scroll-reveal>
                        <h5>Jelena Giljanović</h5>
                        <span class="_rating">5.0</span>
                        <span class="_text">Spacious house with charming interior. Everything is new and it is extremely clean. Big yard outside with swimming pool and summer kitchen for cooking and barbeque. Beautiful view on vineyards in surrounding. Friendly and kind host. Perfect place for vacation.</span>
                    </div>
                </div>
                <div class="w-full md:w-1/3 px-2 md:px-base xl:px-lg mb-lg">
                    <div class="review-box text-white" v-scroll-reveal>
                        <h5>Vedrana Čulo Gusić</h5>
                        <span class="_rating ">5.0</span>
                        <span class="_text">Real feeling of Croatia and Istria. Lovely yard, a lot of space in the house, extra clean and cousy. I recommend it for family with children or sporty spirit couples. Cycling, running, swimming... a lot to do! Thanks!</span>
                    </div>
                </div>
                <div class="w-full md:w-1/3 px-2 md:px-base xl:px-lg mb-lg">
                    <div class="review-box text-white" v-scroll-reveal>
                        <h5>Sascha Meyer</h5>
                        <span class="_rating ">5.0</span>
                        <a href="https://www.facebook.com/sascha.meyer.585/posts/1902240499842779:0" target="_blank" class="_text text-white active:text-primary hover:text-primary trans-color">Das Haus liegt umringt von Weinbergen direkt in der Natur. Es wurde mit viel Liebe renoviert/modernisiert. Die Räumlichkeiten sind sehr großzügig, geschmackvoll eingerichtet...</a>
                    </div>
                </div>
                <div class="w-full md:w-1/3 px-2 md:px-base xl:px-lg mb-lg">
                    <div class="review-box text-white" v-scroll-reveal>
                        <h5>Silver Neck</h5>
                        <span class="_rating ">5.0</span>
                        <span class="_text">Top,.... absolut top! Schönes Haus, idyllisch gelegen, großer Pool, netter Vermieter,...... sehr zu empfehlen!</span>
                    </div>
                </div>
                <div class="w-full md:w-1/3 px-2 md:px-base xl:px-lg mb-lg">
                    <div class="review-box text-white" v-scroll-reveal>
                        <h5>Jasper Bang</h5>
                        <span class="_rating ">5.0</span>
                        <a href="https://www.facebook.com/jesper.bang.507/posts/2239267319640611:0" target="_blank" class="_text text-white active:text-primary hover:text-primary trans-color">Lækkert hus som er godt indrettet. Det er velholdt og rent og pænt. Udenfor er der flot udsigt og flere steder hvor man kan slappe af. Dejligt pool område. Vi havde en dejlig ferie...</a>
                    </div>
                </div>
                <div class="w-full md:w-1/3 px-2 md:px-base xl:px-lg mb-lg">
                    <div class="review-box text-white" v-scroll-reveal>
                        <h5>Leahcim Rengia</h5>
                        <span class="_rating ">5.0</span>
                        <span class="_text">Very nice quarters, gorgeous in the middle of the vineyards. Pool for the kids, Kitchen, perfectly furnished house. Very recommended!</span>
                    </div>
                </div>
            </div>

            <div class="flex justify-center mt-lg xl:mt-gap">
                <a href="https://www.facebook.com/pg/villakanedolo/reviews/?ref=page_internal" target="_blank" class="btn" v-html="$t('btn.review')"></a> 
            </div>
        </div>
    </section>
</template>

<script>
export default {}
</script>
